import * as React from 'react';
import { css } from 'aphrodite';
import { ISelectOption } from '../../../../web/components/DeprecatedSelect';
import { IRepeaterItem, Repeater } from '../../ContactInfo/components/Repeater';
import { styleSheet } from '../styles';
import { generateTimeOptions } from '../utils';
import { OptionSelect } from './OptionSelect';

interface IRange {
	start: ISelectOption<number>;
	end: ISelectOption<number>;
}

interface IProps {
	dayLabel: string;
	disabled: boolean;
	onChange: (values: IRange[]) => void;
	values: IRange[];
}

enum TimeRangeKey {
	End = 'end',
	Start = 'start',
}

export const TimeRangeRepeater: React.FC<IProps> = React.memo(function TimeRangeRepeaterBase({
	dayLabel,
	disabled,
	onChange,
	values,
}) {
	const handleRepeaterChange = (newValues: IRepeaterItem<IRange>[]) => {
		const sorted = newValues
			?.map(i => i.content)
			?.sort((a, b) => {
				if (a.start.dataContext < b.start.dataContext) {
					return -1;
				}
				if (a.start.dataContext > b.start.dataContext) {
					return 1;
				}
				return 0;
			});
		onChange(sorted);
	};
	const options: ISelectOption<number>[] = [...generateTimeOptions()];
	return (
		<Repeater<IRange>
			disabled={disabled}
			initialValues={values}
			onChange={handleRepeaterChange}
			contentToAdd={{
				end: options[17],
				start: options[8],
			}}
		>
			{(item, handleContentChange) => {
				const handleTimeChange = (key: TimeRangeKey) => (option: ISelectOption<number>) => {
					const newTimeRange = { ...item?.content, [key]: option };
					handleContentChange(newTimeRange);
				};
				const content = item?.content;
				const endOptions = [...options]?.filter(i => i.dataContext > content?.start?.dataContext);
				const startOptions = [...options]?.filter(i => i.dataContext < content?.end?.dataContext);
				const resolvedStartOptions = startOptions?.length <= 0 ? options : startOptions;
				const resolvedEndOptions = endOptions?.length <= 0 ? options : endOptions;
				return (
					<div className={css(styleSheet.dialogRow)}>
						<div className={css(styleSheet.timeSelect)}>
							<OptionSelect
								ariaLabel={`${dayLabel} start time`}
								disabled={disabled}
								options={resolvedStartOptions}
								selected={content?.start}
								onSelect={handleTimeChange(TimeRangeKey.Start)}
							/>
						</div>
						<span>to</span>
						<div className={css(styleSheet.timeSelect)}>
							<OptionSelect
								ariaLabel={`${dayLabel} end time`}
								disabled={disabled}
								options={resolvedEndOptions}
								selected={content?.end}
								onSelect={handleTimeChange(TimeRangeKey.End)}
							/>
						</div>
					</div>
				);
			}}
		</Repeater>
	);
});
